module.exports = __webpack_public_path__ + "img/Human Resource.a720ee1d.svg";